import React from 'react'
import Button from 'aria-viewer/tour/components/buttons/button'
import injectSheet from 'react-jss'
import classNames from 'classnames'
import compose from 'recompose/compose'
import pure from 'recompose/pure'

const styleSheet = theme => ({
    wrapper: {
        width: '100%',
        height: '100%',
        position: 'relative',
        cursor: 'pointer',
        pointerEvents: 'all',
        zIndex: 200,
    },
    hidden: {
        display: 'none',
    },
    infoIcon: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
        color: theme.palette.common.white,
        fontSize: 28,
    },
    border: {
        border: '1.3px solid #fff',
        width: 'calc(100% + 2px)',
        height: 'calc(100% + 2px)',
        borderRadius: '50%',
        position: 'absolute',
        boxSizing: 'border-box',
        top: -1,
        left: -1,
        animationDuration: `1.1s`,
        animationName: 'infoButtonBorderPulse',
        animationIterationCount: 'infinite',
        pointerEvents: 'none',
    },
    '@keyframes infoButtonBorderPulse': {
        '0%': {
            transform: 'scale(1)',
            opacity: '1',
        },
        '100%': {
            transform: 'scale(1.6)',
            opacity: '0',
        },
    },
})

const style = injectSheet(styleSheet)

const StopInfoButton = ({ classes, children, onClick, buttonClassName, hideInfoButton, audioIsPlaying }) => (
    <div className={classNames({ [classes.hidden]: hideInfoButton })}>
        <Button className={buttonClassName} onClick={onClick} theme={'button_rounded_transparent'}>
            <div className={classes.wrapper}>
                {audioIsPlaying && <div className={classes.border} />}
                <div className={classes.infoIcon}>i</div>
            </div>
            {children}
        </Button>
    </div>
)

export default compose(
    style,
    pure
)(StopInfoButton)
